import React, {useState, useEffect} from 'react';

interface InputFieldProps {
    placeholder: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    inputRef?: React.RefObject<HTMLInputElement>; // Make the ref prop optional
}

const InputFieldFilter: React.FC<InputFieldProps> = ({
                                                         placeholder,
                                                         value,
                                                         onChange,
                                                         inputRef, // Receive inputRef as a prop
                                                     }) => {
    const [isFocused, setIsFocused] = useState(false);

    const inputStyles = {
        width: '100%',
        padding: '0.2rem 1rem',
        border: '1px solid #bfbc7c',
        borderRadius: '0.25rem',
        outline: 'none',
        transition: 'border-color 0.2s',
        boxShadow: isFocused ? '0 0 0 2px #bfbc7c' : 'none',
    };

    useEffect(() => {
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputRef]);

    return (
        <div className="">
            <input
                type="text"
                style={inputStyles}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                ref={inputRef && inputRef}
            />
        </div>
    );
};

export default InputFieldFilter;